import { render, staticRenderFns } from "./TableListConfig.vue?vue&type=template&id=47f863a2&scoped=true"
import script from "./TableListConfig.vue?vue&type=script&lang=js"
export * from "./TableListConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f863a2",
  null
  
)

export default component.exports